import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { AssociatedAccountsComponent } from '../associated-accounts/associated-accounts.component';

@Component({
  selector: 'app-edit-system-info',
  templateUrl: './edit-system-info.component.html',
  styleUrls: ['./edit-system-info.component.scss']
})
export class EditSystemInfoComponent implements OnInit {
  @Input() id = ''; @Input() ctryCode = ''; isActive: boolean = true; isBlock: boolean = false; isPermenentBlock: boolean = false; isResetPassword: boolean = false;
  wrapper: KeyValues5; blockStatusWhileLoading: boolean = false; blockPerStatusWhileLoading: boolean = false; message: string = ''; isRedAlert: boolean = true; reason: string = '';
  lstSectionConfigKeys: string[] = ["edit_system_info"];
  constructor(private activeModal: NgbActiveModal, private languageManagementService: LanguageManagementService, public localService: LocalService, public profileManagementService: ProfileManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    this.profileManagementService.editSystemInfo(this.id, this.ctryCode).subscribe(result => {
      this.wrapper = result;
      this.onSet();
    });
  }

  onSet() {
    this.isActive = this.wrapper.v1 == '1';
    this.isResetPassword = this.wrapper.v2 == '1';
    this.isPermenentBlock = this.wrapper.v3 == '2';
    if (this.isPermenentBlock)
      this.isBlock = true;
    else
      this.isBlock = this.wrapper.v3 == '1';
    this.blockStatusWhileLoading = this.isBlock;
    this.blockPerStatusWhileLoading = this.isPermenentBlock;
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.profileManagementService.saveSystemInfo(this.id, this.ctryCode, this.onGetData()).subscribe(result => {
        if (result.status == Status.Success || result.status == Status.SuccessWithMoreAction) {
          this.activeModal.close({ event: TriggeredEvent.Ok });
          if (result.status == Status.SuccessWithMoreAction) {
            const modalRef = this.modalService.open(AssociatedAccountsComponent);
            modalRef.componentInstance.userOrBusinessId = this.id;
            modalRef.componentInstance.isUser = true;
            modalRef.componentInstance.countryCode = this.ctryCode;
          }
        }
      });
    }
  }

  onGetData(): KeyValues5 {
    let data = {
      key: this.id,
      v1: this.isActive ? '1' : '0',
      v2: this.isResetPassword ? '1' : '0',
      v3: this.reason,
      v4: this.isBlock ? '1' : '0',
      v5: this.isPermenentBlock ? '1' : '0'
    } as KeyValues5;
    return data;
  }

  onClick(index) {
    switch (index) {
      case 1: {
        if (this.isPermenentBlock)
          this.isBlock = true;
      } break;
    }
  }

  doCheck() {
    this.message = '';
    this.reason = this.reason.trim();
    if (this.isBlock != this.blockStatusWhileLoading && this.reason == '') {
      this.message = this.localService.languageContent.edit_system_info.block_or_unblock_reason_required;
    }
    return this.message == '';
  }

  onForceLogOut() {
    this.profileManagementService.resetCurrentToken(this.localService.getLoginAsCountryCode() , this.id).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
    });
  }
}
